import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClerk } from '@clerk/react';

/**
 * Linkable sign-out endpoint. Calls clerk.signOut() on mount and bounces
 * the user back to the homepage. Useful for "wrong account?" affordances
 * in emails and for bookmark-style escape hatches when the UserButton
 * isn't reachable (e.g. mid-flow on an error page).
 *
 * Errors are swallowed and we still navigate home — there's no useful
 * "sign-out failed" recovery the user can take, and leaving them stuck
 * on a spinner is worse than landing home in whatever state they were.
 */
export default function SignOutPage() {
  const clerk = useClerk();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    clerk
      .signOut()
      .catch((err) => console.warn('[sign-out] signOut failed', err))
      .finally(() => {
        if (!cancelled) navigate('/', { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [clerk, navigate]);

  return (
    <div className="setup-state">
      <div className="setup-spinner" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
      <h2>Signing you out</h2>
      <p>Taking you back to the homepage in a moment.</p>
    </div>
  );
}
